import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import FavouriteBtn from '../../atoms/FavouriteBtn/FavouriteBtn';
import LazyPicture from '../../atoms/LazyPicture';
import RouterLink from '../../atoms/RouterLink';
import Reminder from '../../atoms/Reminder/Reminder';
import CuratorPicks from '../../atoms/CuratorPicks/CuratorPicks';
import { convertDate } from '../Events';
import { pathJoin, getMediaHost, injectImageResolution, get, getListingItemURL } from '../../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { BlurCard, EBlurCardImageTypes, isShowRuleIsHide } from '../../atoms/BlurCard/BlurCard';
import { differenceInDays } from 'date-fns';
var EventBlock = function EventBlock(_ref) {
  var event = _ref.event,
    curatorsCopy = _ref.curatorsCopy,
    lang = _ref.lang,
    callback = _ref.callback,
    analytics = _ref.analytics,
    _ref$multipleDates = _ref.multipleDates,
    multipleDates = _ref$multipleDates === void 0 ? '' : _ref$multipleDates,
    hostLink = _ref.hostLink,
    linksTarget = _ref.linksTarget,
    removeFavButton = _ref.removeFavButton,
    widgetAnalytics = _ref.widgetAnalytics,
    countryItems = _ref.countryItems,
    themeValues = _ref.themeValues,
    inSlider = _ref.inSlider;
  var eventsAnalytics = analytics.eventsAnalytics,
    params = analytics.params;
  var imgAlt = get(event, 'title');
  var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), event.image])), 340, 243);
  var curators = get(event, 'curators.curators');
  var eventIsBusiness = get(event, 'eventIsBusiness');
  var currentDate = function () {
    var currentDate = new Date(new Date().getTime());
    currentDate.setUTCHours(0, 0, 0, 0);
    return currentDate;
  }();
  var numberOfDaysBeforeEventStart = event.datesRange ? differenceInDays(new Date(event.datesRange.from_formatted), currentDate) : "datesRange is not provided";
  var numberOfDaysBeforeEventEnd = event.datesRange ? differenceInDays(new Date(event.datesRange.to_formatted ? event.datesRange.to_formatted : event.datesRange.from_formatted), currentDate) : "datesRange is not provided";
  var eventStarted = event.datesRange && (differenceInDays(currentDate, new Date(event.datesRange.from_formatted)) >= 0 ? true : false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isShowRuleIsHide(event) ? /*#__PURE__*/React.createElement("div", {
    className: "events__item"
  }, /*#__PURE__*/React.createElement(BlurCard, {
    hint: event,
    lang: lang,
    cardType: EBlurCardImageTypes.event,
    hitAnalytics: eventsAnalytics,
    hitParams: params,
    reminderTheme: themeValues,
    countryItems: countryItems,
    hitInSlider: inSlider,
    showWithAnimation: true,
    isEventBlur: true
  })) : /*#__PURE__*/React.createElement("div", {
    className: "col-12  events__item-col",
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__image-wrap"
  }, event.image && /*#__PURE__*/React.createElement(RouterLink, {
    href: getListingItemURL(hostLink, event.urlSlug, event.url),
    openInSameTab: true,
    linksTarget: linksTarget,
    onClick: function onClick() {
      return !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['bannerClickAnalytics'], params), event.englishTitle);
    },
    title: imgAlt
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "events__image",
    src: imgSrc,
    alt: imgAlt
  })))), /*#__PURE__*/React.createElement("div", {
    className: "events__info"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(CuratorPicks, {
    curators: curators,
    copy: curatorsCopy,
    linksTarget: linksTarget,
    analytics: {
      eventsAnalytics: eventsAnalytics,
      params: params,
      name: event.englishTitle
    }
  })), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__text-sight"
  }, event.category && event.category.join(', '))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.3
  }, /*#__PURE__*/React.createElement("a", {
    className: "events__item-title",
    target: linksTarget ? linksTarget : '_self',
    href: getListingItemURL(hostLink, event.urlSlug, event.url),
    "aria-label": "Event",
    onClick: function onClick() {
      return !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), event.englishTitle);
    }
  }, event.title)), event.datesRange && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.4
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__date-item"
  }, event.eventNextAvailableDate ? " ".concat(multipleDates, " ").concat(convertDate(event.eventNextAvailableDate, '', lang)) : " ".concat(event.datesRange) && convertDate(event.datesRange.from_formatted, event.datesRange.from_formatted === event.datesRange.to_formatted ? '' : event.datesRange.to_formatted, lang))), /*#__PURE__*/React.createElement("div", {
    className: "events__push-bottom"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.6
  }, !eventIsBusiness && /*#__PURE__*/React.createElement(Reminder, {
    lang: lang,
    event: event,
    countryItems: countryItems,
    themeValues: themeValues,
    modeSlider: inSlider,
    eventsAnalytics: eventsAnalytics,
    params: params,
    numberOfDaysBeforeEventStart: numberOfDaysBeforeEventStart,
    numberOfDaysBeforeEventEnd: numberOfDaysBeforeEventEnd,
    eventStarted: eventStarted
  }))), !removeFavButton && /*#__PURE__*/React.createElement(FavouriteBtn, {
    callback: callback,
    itemId: event && event.objectID,
    classes: 'events__fav-btn',
    analyticsClick: function analyticsClick(eventTitle) {
      return !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['addToFavAnalytics'], params), "".concat(eventTitle, ": ").concat(event.englishTitle));
    }
  })))));
};
export default EventBlock;